import { render, staticRenderFns } from "./dataSource.vue?vue&type=template&id=52843fe3&"
import script from "./dataSource.vue?vue&type=script&lang=js&"
export * from "./dataSource.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports